import {CustomerGroupPrice, updatedProductGroupToggle} from "../../../services/productGroupService";
import {useDispatch, useSelector} from "react-redux";
import {IGlobalProduct, IState} from "../../../types/state";
import React, {
    FC,
    Fragment,
    MouseEvent as ReactMouseEvent,
    ReactNode,
    useEffect,
    useRef,
    useState
} from "react";
import {useToast} from "../../../atoms/Toast/useToast";
import {useRouter} from "next/router";
import cls from "./customInnerPage.module.scss";
import {CheckToastSvg, FailSvg, HeartActive, HeartSvg} from "../../../svg";
import {wishlistAddItem, wishlistRemoveItem} from "../../../store/wishlist";
import Script from "next/script";
import {IProduct, ISizeChart, TranslationsType} from "../../../types/homePageTypes";
import CustomDetails from "./CustomDetails";
import {ICurrencies} from "../Wrappers/MainLayout";
import {ICustomerGroupPrices, IRequestFormDetails} from "../../../pages/[productSlug]";
import CustomSideBar from "./CustomSideBar";
import CustomQuantityTable from "./CustomQuantityTable";
import CustomSocialLinks from "./CustomSocialLinks";
import CustomDetailTabButtons from "./CustomDetailTabButtons";
import CustomInfoPart from "./CustomInfoPart";
import {
    addCartDivStyleToggleSimple,
    dangerOrSuccessStyleSimple,
    isSelectedDetailSectionClass,
    schemaProduct,
    showBoxAboutDetails, useCustomOptions,
    useFetchCartToken
} from "./helpers";
import CustomProductGallery from "./CustomProductGallery";
import InputNumber from "../../shared/InputNumber";
import {handleAddCard, openUpCrossProd} from "../../shared/ProductCard/helpers";
import {IFormComponentType} from "../../builder/types";
import {setNotFilledOptionsAction} from "../../../store/product";

interface ICustomProduct {
    dbName: string;
    domain: string;
    productSlug: string;
    selectedRate: ICurrencies;
    product: IProduct;
    backOrderValue: string;
    customerGroupPrices: Array<ICustomerGroupPrices>;
    translationsData: TranslationsType;
    selectedLocale: string;
    schemaBrandName: string;
    showDetailsInFront: boolean;
    showBuilderComponents: (id: number) => Record<"true" | "false", ReactNode>;
    showBuilderData: boolean;
    requestFormInfo: IFormComponentType | null;
    requestFormDetails: IRequestFormDetails;
    sizeChart: ISizeChart | null
}

const CustomProduct: FC<ICustomProduct> = (
    {
        dbName,
        productSlug,
        domain,
        selectedRate,
        product,
        backOrderValue,
        customerGroupPrices,
        translationsData,
        selectedLocale,
        schemaBrandName,
        showDetailsInFront,
        showBuilderComponents,
        showBuilderData,
        requestFormInfo,
        requestFormDetails,
        sizeChart
    }
) => {
    const [clientSideProduct, setClientSideProduct] = useState<IProduct>(product);
    const [resultFilterGroup, setResultFilterGroup] = useState<{
        element: CustomerGroupPrice[];
        display: "flex" | "none"
    }>({
        element: [],
        display: "none"
    })
    const {
        flats: [{
            name: productName = "",
            description: productDesc = "",
            min_price: productMinPrice = null,
            special_price: productSpecialPrice = null,
            short_description: productShortDesc = "",
            price: productPrice = null,
            price_html: productPriceHtml = null,
            min_qty: productMinQtyServer = 1
        } = {}] = [],
        images: [productImgPath = ""] = [],
        id: productId,
        sku: productSku = "",
        details: productDetails = [],
        sku_option: {name: productSkuOptionName = "SKU"} = {},
        short_description_option: {name: productShortDescOptionName = ""} = {},
        description_option: {name: productDescOptionName = ""} = {},
        product_options = [],
        qty: [productInitialQty]
    } = product
    const productMinQty = !(!!productMinQtyServer) || !(!!+productMinQtyServer) ? 1 : productMinQtyServer;
    const [productQuantity, setProductQuantity] = useState<number>(+productMinQty || 1);
    const [maxQty, setMaxQty] = useState<number>(product?.qty[0]);
    const cart = useSelector((state: IState) => state.cart);
    const findExistItem = cart?.items?.find(elem => elem?.product?.id === productId);

    useEffect(() => {
        if (+backOrderValue) {
            setMaxQty(50000);
        } else if (cart?.items?.length) {
            if (findExistItem) {
                setMaxQty(Number(+product?.qty[0] - +findExistItem?.quantity))
            }
        } else if (!cart?.items?.length) {
            setMaxQty(Number(product?.qty[0]))
        }
    }, [findExistItem?.quantity]);
    useEffect(() => {
        setProductQuantity(+productMinQty);
        setClientSideProduct(product)
    }, [productSlug]);

    const [isSelectDetail, setIsSelectDetail] = useState<boolean>(!productDesc);
    const cartToken = useSelector((state: IState) => state.cartToken);
    const {customerGroupId, token: customerToken} = useSelector((state: IState) => state.customer);
    const signed = useSelector((state: IState) => state.customer.authenticated);
    const wishlist = useSelector((state: IState) => state.wishlist);
    const isProductInWishList = wishlist?.find((item: IGlobalProduct) => item.id === productId)
    const [wishIcon, setWishIcon] = useState<React.JSX.Element>(<HeartSvg/>)
    useEffect(() => {
        setWishIcon(!!isProductInWishList ? <HeartActive className={cls["inner-wishlist"]}/> : <HeartSvg/>)
    }, [isProductInWishList]);
    const dispatch = useDispatch();
    const optionValues = useSelector(((state: IState) => state.product.optionValues));
    const toast = useToast();
    const {asPath, push: routerPush} = useRouter();
    const rootRef = useRef<HTMLDivElement>(null)

    const isProductInStock = product.qty[0] > 0 || !!parseFloat(backOrderValue)
    const addToast = (error?: boolean) => {
        if (error) {
            toast.open(
                <span className="d-flex chek-fms">
                    <FailSvg/>
                    {translationsData.ProductNotAvailable}
                </span>
            )
        } else {
            if (isProductInStock) {
                toast.open(
                    <span className="d-flex chek-fms">
                        <CheckToastSvg/>
                        {translationsData.ToastAddToCart}
                   </span>
                )
            }
        }
    }

    useEffect(() => {
        const handleGroupPriceDisplay: { true: "flex", false: "none" } = {
            "true": "flex",
            "false": "none"
        }
        setResultFilterGroup({
            element: updatedProductGroupToggle(
                customerGroupPrices,
                customerGroupId,
                product,
                true,
                selectedRate?.exchange_rate?.rate || "1"
            ),
            display: handleGroupPriceDisplay[`${!!customerGroupPrices.length}`]
        })
    }, [productSlug]);

    const schema = schemaProduct(asPath, productName, productDesc, productImgPath, productSku, productId, dbName, domain, schemaBrandName)
    const { customOptions, refsMap } = useCustomOptions(
        {
            setClientSideProduct,
            productMinPrice,
            productSpecialPrice,
            productPrice,
            selectedRate,
            asPath,
            productSlug
        }
    )
    useFetchCartToken(cartToken)

    const selectTab = (e: ReactMouseEvent<HTMLDivElement>) => {
        setIsSelectDetail((e.target as HTMLDivElement).id === "detail")
    }
    const quantityColumnHandler = (title: string, isQuantity: boolean) => {
        const handleQuantity = ({qty, value}: { qty: string; value: string | number }) => {
            return {
                "true": {
                    divTableStyle: {background: "#EFEFEF"},
                    priceClassToggle: "quantity_item_span",
                    priceSpan: qty,
                    titleSpan: translationsData?.AndMore
                },
                "false": {
                    divTableStyle: {},
                    priceClassToggle: "price_item_span",
                    priceSpan: `${selectedRate?.symbol}${value}`,
                    titleSpan: ""
                }
            }
        }
        return (
            <div className={cls["quantity_table_row"]}>
                <div style={handleQuantity({qty: "", value: ""})[`${isQuantity}`].divTableStyle}
                     className={cls["quantity_table_item"]}>
                <span className={cls["quantity_item_span"]}>
                    {translationsData?.[title]}
                </span>
                </div>
                {resultFilterGroup.element.map((groupItem: { qty: string; value: string | number }) => (
                    <div style={handleQuantity(groupItem)[`${isQuantity}`].divTableStyle}
                         className={cls["quantity_table_item"]}>
                    <span className={cls[handleQuantity(groupItem)[`${isQuantity}`].priceClassToggle]}>
                        {handleQuantity(groupItem)[`${isQuantity}`].priceSpan}
                        {" "}
                        {handleQuantity(groupItem)[`${isQuantity}`].titleSpan}
                    </span>
                    </div>
                ))}
            </div>
        )
    }
    const handleWishIconClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        if (!signed) {
            toast.open(
                <span className="d-flex faild-toast-fms">
                    <FailSvg/>
                    {translationsData.ToastSignIn}
                </span>
            )
        } else {
            !!isProductInWishList ?
                dispatch(wishlistRemoveItem(product.id))
                : dispatch(wishlistAddItem(product, selectedLocale))
            const toastChildren = {
                "true": {svg: <FailSvg/>, title: translationsData?.ToastWishListRemove},
                "false": {svg: <CheckToastSvg/>, title: translationsData?.ToastWishList}
            }
            toast.open(
                <span className="d-flex faild-toast-fms">
                    {toastChildren[`${!!isProductInWishList}`].svg}
                    {toastChildren[`${!!isProductInWishList}`].title}
                </span>
            )
        }
    }

    const priceHtmlAvailable = {
        "true": product?.flats[0]?.price_html?.map((e: string, i: number) => (
            <span key={i} className={cls["product_price_html"]}>{e}</span>
        )),
        "false": <></>
    }

    const handleZero = (value: number) => {
        return {
            true: +value,
            false: 1
        }
    }

    const handleCustomerGroupPrice = {
        "true": <CustomQuantityTable
            QuantityDiscount_INTL={translationsData?.QuantityDiscount}
            quantityColumnHandler={quantityColumnHandler}
            displayFilterGroup={resultFilterGroup.display}
        />,
        "false": null
    }

    const isButtonDisabled = {
        "true": !(!!+backOrderValue),
        "false": false
    }


    const descriptions = (
        <div className="product-inner-long-description">
            <div style={{paddingLeft: "30px"}}>
                <div dangerouslySetInnerHTML={{__html: productDesc}}/>
            </div>
        </div>
    )

    const details = <CustomDetails
        details={productDetails}
        isSelectDetail={isSelectDetail}
        showDetailsInFront={showDetailsInFront}
        translationsData={translationsData}
        dbName={dbName}
        domain={domain}
    />
    const handleAddCartClickLocal = async (quantity: number = 1) => {
        if (product_options?.length > 0) {
            const filterRequiredOptions = product_options.filter((option) => Number(option?.required));
            if (filterRequiredOptions?.length) {
                const everyItemExist = filterRequiredOptions?.filter((item) => {
                    return !optionValues.some((option) => option.id === item.id);
                }).map(item => item.id)
                if (everyItemExist.length > 0) {
                    dispatch(setNotFilledOptionsAction(everyItemExist));
                    return;
                }
            }
        }
        dispatch(setNotFilledOptionsAction([]));
        return await handleAddCard({
            openUpCrossProd: () => {
                return openUpCrossProd(
                    {
                        dispatch,
                        productId,
                        selectedLocale,
                        selectedRate,
                        product
                    }
                )
            },
            dispatch,
            data: {
                product,
                quantity,
                cartToken,
                customer: { token: customerToken },
                selectedLocale,
                selectedCurrCode: selectedRate.code,
                optionsObject: Object.keys(customOptions?.customizable_options).length > 0 ? customOptions : null,
                addToast
            },
            routerPush,
            isProductInStock,
        })
    }

    return (
        <Fragment>
            <Script
                id={schema.name}
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
                defer
            />
            <div>
                <div className={cls["product__content"]}>
                    <CustomProductGallery images={product.images} dbName={dbName}/>
                    <div className={cls.product__info}>
                        <CustomInfoPart
                            product={product}
                            productName={productName}
                            productSkuOptionName={productSkuOptionName}
                            productSku={productSku}
                            selectedCurrSymbol={selectedRate?.symbol}
                            selectedCurrCode={selectedRate?.code}
                            clientSidePrice={{
                                price: clientSideProduct.flats[0].price,
                                specialPrice: clientSideProduct.flats[0].special_price || 0
                            }}
                            priceHtmlAvailable={priceHtmlAvailable[`${!!productPriceHtml}`]}
                            productShortDescOptionName={productShortDescOptionName}
                            productShortDesc={productShortDesc}
                            productOptions={product_options}
                            translationsData={translationsData}
                            refsMap={refsMap}
                            sizeChart={sizeChart}
                            dbName={dbName}
                            domain={domain}
                        >
                            {handleCustomerGroupPrice[`${resultFilterGroup.element.length > 0}`]}
                        </CustomInfoPart>
                        <div className={cls.sidebar__details}>
                            {!showDetailsInFront && !!productDetails.length && <CustomDetails
                                details={productDetails}
                                isSelectDetail={isSelectDetail}
                                showDetailsInFront={true}
                                translationsData={translationsData}
                                dbName={dbName}
                                domain={domain}
                            />}
                        </div>
                        <ul className={`${cls.product__meta} ${cls.simple__meta}`}>
                            <li className={cls["product__meta-availability"]}>
                                <span className={dangerOrSuccessStyleSimple[`${isProductInStock}`].className}
                                      style={{fontSize: "18px"}}>
                                    {translationsData?.[dangerOrSuccessStyleSimple[`${isProductInStock}`].ItlKey]}
                                </span>
                            </li>
                            <div className={`${cls["product__actions-item"]} ${cls["product-inner-quantity"]}`}>
                                <InputNumber
                                    id="product-quantity"
                                    aria-label="Quantity"
                                    className={cls["product__quantity"]}
                                    size="lg"
                                    min={handleZero(productMinQty)[`${!!productMinQty}`]}
                                    max={maxQty}
                                    value={handleZero(productQuantity)[`${!!productQuantity}`]}
                                    onChange={(quantity: number) => {
                                        if (quantity > maxQty) {
                                            setProductQuantity(maxQty)
                                        } else {
                                            setProductQuantity(quantity)
                                        }
                                    }}
                                />
                            </div>
                        </ul>
                        <CustomSideBar
                            ProductAddToCart_INTL={translationsData?.AddToCartButtonTitle}
                            actionClassName={addCartDivStyleToggleSimple[`${isProductInStock}`]}
                            handleCardClick={handleAddCartClickLocal}
                            isButtonDisabled={isButtonDisabled[`${productInitialQty === 0}`]}
                            wishListButtonClick={handleWishIconClick}
                            wishIconClicked={wishIcon}
                            minimalQty={handleZero(productMinQty)[`${!!productMinQty}`]}
                            maximalQty={maxQty}
                            inpValQuantity={handleZero(productQuantity)[`${!!productQuantity}`]}
                            setQuantity={setProductQuantity}
                            requestFormInfo={requestFormInfo}
                            requestFormDetails={requestFormDetails}
                        />
                        <CustomSocialLinks dbName={dbName} domain={domain} productSlug={productSlug}/>
                    </div>
                </div>
                {showBuilderComponents(2)[`${showBuilderData}`]}
                <CustomDetailTabButtons
                    boxAboutDetailsClass={showBoxAboutDetails[`${showDetailsInFront}`]}
                    isSelectedDetailSectionClass={isSelectedDetailSectionClass(descriptions, details)[`${isSelectDetail}`]}
                    productDescOptionName={productDescOptionName}
                    Details_INTL={translationsData?.Details}
                    selectTab={selectTab}
                    showDescription={!!productDesc}
                    showDetailsInFront={showDetailsInFront}
                />
                {isSelectedDetailSectionClass(descriptions, details)[`${isSelectDetail}`].content}
            </div>
        </Fragment>
    );
};

export default CustomProduct;
